/** Tuned domain numbers, kept together so beta adjustments are one-file changes. */
export const PLAN_REVISION = {
  // Spec §6.3; provisional and tuned in beta.
  minSurfacings: 4,
} as const;

export const ONBOARDING_LIMITS = {
  // Spec §6.1; fixed product limit, not provisional.
  maxDirections: 3,
  // Spec §6.1; fixed product limit, not provisional.
  maxTargetBehaviors: 3,
  // Spec §6.1; fixed product limit, not provisional.
  minPlans: 3,
  // Spec §6.1; fixed product limit, not provisional.
  maxPlans: 6,
} as const;
